import { render } from "./ProdCategoriesNewPage.vue?vue&type=template&id=4f26ab37&ts=true"
import script from "./ProdCategoriesNewPage.vue?vue&type=script&lang=ts"
export * from "./ProdCategoriesNewPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__